import { toast } from "react-toastify";
import { ERROR_STATUS } from "../../status/status";
import { delCookie, getCookie } from "./actions";

//data fetch
const SERVER_URL = process.env.REACT_APP_API
  ? process.env.REACT_APP_API
  : "/api";

export const fetchData = async (url, params) => {
  const token = getCookie("authToken");
  try {
    const formattedUrl = params ? `${url}?${params}` : url;

    const res = await fetch(`${SERVER_URL}${formattedUrl}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${token}`,
      },
    });

    if (res.status === 401) {
      delCookie("authToken");
      window.location.href = "/login";
    }
    if (res.status === 403) {
      toast.error(ERROR_STATUS.SUBSCRIPTION);
    }

    if (res.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    console.log(err);
    toast(ERROR_STATUS.SERVER, { type: "error" });
  }
};
